export default function hoursBetween(future: Date, past: Date) {
  return (future.getTime() - past.getTime()) / (1000 * 60 * 60);
}
